import React from 'react';

import RawButton from '@swf/components/StarsButton/RawButton';

import styles from './Gateway.scss';

interface Description {
  title: JSX.Element;
  camera: string;
  upload: string;
}
interface Props {
  messages: Description;
}

const Gateway: React.FC<Props> = ({ messages }) => (
  <>
    <div data-jcs-element="provider__container" />
    <form className="button-container button-cancel-container button-gateway-container">
      <RawButton
        data-jcs-element="gateway__upload__toggle"
        variant="primary"
        className={styles.toggleButton}
      >
        <div data-jcs-element="gateway__upload__toggle__upload__label">{messages.upload}</div>
        <div data-jcs-element="gateway__upload__toggle__camera__label">{messages.camera}</div>
      </RawButton>
    </form>
  </>
);

export default Gateway;
